// Deep-link contract between the Forecast & Predictability dashboard and the
// Forecast Lab. One source of truth for the query-param names so the producers
// (dashboard tiles / chart link) and the consumer (ForecastLabPage + Explorer)
// can't drift apart. No React — pure URL helpers.

export const LAB_PATH = "/forecast-lab";

const TABS = ["model-studio", "explorer", "scenario", "calibration", "model-ops"];
const SCOPES = ["insights", "allocation"];
const LENSES = ["cost-series", "budgets", "allocation"];
const HORIZONS = [30, 60, 90];

// forecastLabUrl builds a deep-link into the Lab. Absent fields are simply
// omitted so the Lab keeps its own defaults for them.
export function forecastLabUrl({ tab = "explorer", scope, lens, horizon, selected } = {}) {
  const p = new URLSearchParams();
  if (tab) p.set("tab", tab);
  if (scope) p.set("scope", scope);
  if (lens) p.set("lens", lens);
  if (horizon != null) p.set("horizon", String(horizon));
  if (selected != null && selected !== "") p.set("sel", String(selected));
  const q = p.toString();
  return q ? `${LAB_PATH}?${q}` : LAB_PATH;
}

// parseForecastLabParams reads a URLSearchParams (or anything with .get) into a
// validated initial-state object. Unknown/absent values fall back to null so
// callers keep their own defaults.
export function parseForecastLabParams(sp) {
  const get = (k) => (sp && typeof sp.get === "function" ? sp.get(k) : null);
  const tabRaw = get("tab");
  const scopeRaw = get("scope");
  const lensRaw = get("lens");
  const horizonNum = Number(get("horizon"));
  const selRaw = get("sel");

  const lens = LENSES.includes(lensRaw) ? lensRaw : null;
  let selected = selRaw != null && selRaw !== "" ? selRaw : null;
  // Budget rows key off a numeric id; cost-series / allocation key off a string.
  if (selected != null && lens === "budgets") {
    const n = Number(selected);
    selected = Number.isFinite(n) ? n : null;
  }

  return {
    tab: TABS.includes(tabRaw) ? tabRaw : null,
    scope: SCOPES.includes(scopeRaw) ? scopeRaw : null,
    lens,
    horizon: HORIZONS.includes(horizonNum) ? horizonNum : null,
    selected,
  };
}
